import { PRODUCT_TYPES } from '@schuettflix/interfaces';

export const PRODUCT_NAME_LABEL = {
    CUSTOM_BULK_MATERIAL: 'productTemplate.primaryBulkGoods',
    CUSTOM_RECYCLED_BULK_MATERIAL: 'productTemplate.recyclingBulkGoods',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'productTemplate.nonHazardousWasteMaterial',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'productTemplate.nonHazardousWasteMaterial',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'productTemplate.hazardousWasteMaterial',
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'productTemplate.hazardousWasteMaterial',
    CUSTOM_TRANSPORT: 'productTemplate.transport',
    CUSTOM_CONCRETE: 'productTemplate.concrete',
    CUSTOM_ASPHALT: 'productTemplate.asphalt',
    CUSTOM_SERVICE: 'productTemplate.customService',
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: 'productTemplate.customServiceAccompanyingDocument',
    CUSTOM_SERVICE_ANALYSIS: 'productTemplate.customServiceAnalysis',
    CUSTOM_SERVICE_WAITING_TIME: 'productTemplate.customServiceWaitingTime',
    CUSTOM_SERVICE_TOLL: 'productTemplate.customServiceToll',
    CUSTOM_SERVICE_TRANSPORT: 'productTemplate.customServiceTransport',
    BULK_MATERIAL: 'productTemplate.primaryBulkGoods',
    RECYCLED_BULK_MATERIAL: 'productTemplate.recyclingBulkGoods',
    TRANSPORT: 'productTemplate.transport',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'productTemplate.nonHazardousWasteMaterial',
    HAZARDOUS_WASTE_DISPOSAL: 'productTemplate.hazardousWasteMaterial',
    NON_HAZARDOUS_WASTE_RECYCLING: 'productTemplate.nonHazardousWasteMaterial',
    HAZARDOUS_WASTE_RECYCLING: 'productTemplate.hazardousWasteMaterial',
    SERVICE_TOLL: 'productTemplate.serviceToll',
    SERVICE_WEIGHING_NOTE: 'productTemplate.serviceWeighingNote',
    SERVICE_ACCOMPANYING_DOCUMENT: 'productTemplate.serviceAccompanyingDocument',
    SERVICE_ENERGY_SURCHARGE: 'productTemplate.serviceEnergySurcharge',
} as const satisfies Record<PRODUCT_TYPES, string>;

export const DEFAULT_PRODUCT_NAME_LABELS = Object.values(PRODUCT_NAME_LABEL);
